import { h, Component } from 'preact';
import { calcChange, formatNumber } from '../../lib/util';
import style from './style';
import { Spinner } from '@cube/blocks';
import { Text } from 'preact-i18n';
import cx from 'classnames';

/*
* This component is heavily based on the stock-info-tablecomponent currently
* found in the the finance-components repo, much of it's functionality was
* removed to only be compatible with finance widgets (Recently Viewed, Most
* Active Stocks, and the My Portfolio)
*/

export default class StockWidgetTable extends Component {
	toSymbols(data) {
		return data && data.rows && data.rows.map( r => r && r.SymbolID ).join();
	}

	render({ data, columns, showHeaders, noData, ...props }) {
		let rows = data && data.rows;

		if (noData) {
			return (
				<div class={cx(style.stockWidgetTable, props.dataTable && style.dataTable)}>
					<table class={style.financeTable}>
						<StockInfoHeaders {...{ columns, showHeaders }} />
					</table>
				</div>
			);
		}

		if (!rows || !rows.length) {
			return (
				<div class={style.spinner}>
					<Spinner style="font-size: 50px" />
				</div>
			);
		}

		return (
			<div class={cx(style.stockWidgetTable, props.dataTable && style.dataTable)}>
				<table class={style.financeTable}>
					<StockInfoHeaders {...{ columns, showHeaders }} />
					<tbody>
						{ rows.map( (row, i) => row && (
							<StockInfoRow
								pos={i}
								symbol={row.SymbolID}
								{...props}
								{...{ columns, row }}
							/>
						)) }
					</tbody>
				</table>
			</div>
		);
	}
}

export const StockInfoHeaders = ({ columns, showHeaders }) => (
	<thead>
		{ showHeaders && (
			<tr>
				{ columns.map( (field, i) => (
					<th>
						{
							showHeaders.splice ?
								showHeaders[i] :
								<Text id={`field-headers.${field}`} />
						}
					</th>
				)) }
			</tr>
		) }
	</thead>
);

export const StockInfoRow = ({ columns, row, ...props }) => (
	<tr>
		{ row && columns.map( col => (
			<NamedField name={col} row={row} {...props} />
		)) }
	</tr>
);


/** Renders a named component from FIELD_COMPONENTS */
const NamedField = ({ name, ...props }) => {
	props.change = calcChange(props.row.Price, props.row.PrevClose);
	let Comp = FIELD_COMPONENTS[name];
	return <Comp {...props} />;
};

/* eslint-disable react/display-name */
const createChangePercentComponent = (className, prevField) => (
	({ row }) => {
		let cl = cx(style.change, style[className]),
			inner = '0.00%';

		if (row.Price > 0 && row[prevField] > 0) {
			let change = calcChange(row.Price, row[prevField]);
			cl = cx(cl, style[change.class]);
			inner = change.price===0 ? '0.00%' : formatNumber(change.percent, { Plus: true, Decimals: 2, Default: '0.00%', Suffix: '%' });
		}
		return <td class={cl}>{inner}</td>;
	}
);

const maxDecimals = 2;
const minDecimals = 2;

const FIELD_COMPONENTS = {
	price: ({ row }) => (
		<td class={style.price}>
			{ formatNumber(row.Price, { Comma: true, Decimals: row.Price < 10 ? maxDecimals : minDecimals, Default: '0.00' }) }
		</td>
	),

	symbol: ({ row, change, ...props }) => {
		let name = props.abbrv ? row.Symbol : row.name;

		return (
			<td class={style.symbol}>
				<a href={`/finance/category/stockdetail/symbol/${row.UniqueSymbol}`}
					data-tracking-text={row.UniqueSymbol}
				>
					{ name || 'Unknown' }
				</a>
			</td>
		);
	},

	name: ({ row, ...props }) => {
		let nameToShow = row.SecurityTypeCode === 'STOCK' ? row.Symbol : row.ShortName;

		return (
			<td class={style.name}>
				<a href={`/finance/category/stockdetail/symbol/${row.UniqueSymbol}`}
					data-tracking-text={row.UniqueSymbol}
				>
					{ nameToShow || row.Symbol || row.ShortName || row.Name || '' }
				</a>
			</td>
		);
	},


	changePrice: ({ row, change }) => (
		change.price ? (
			<td class={cx(style.change, style[change.class])}>
				{ formatNumber(change.price, { Plus: true, Decimals: row.Price < 10 ? maxDecimals : minDecimals, Default: '0.00' }) }
			</td>
		) : (
			<td class={cx(style.change, style[change.class])}>0.00</td>
		)
	),

	changePercent: createChangePercentComponent('changePercent', 'PrevClose')

};
